console.log('From product component!!!');